import { useState } from "react";
import { UsersListLoading } from "../../Reviews/Review/users-list/components/loading/UsersListLoading";
import { KTCardBody } from "../../../../_metronic/helpers";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { ApprovalModal } from "../ApprovalModal/ApprovalModal";

const headers = [
  { title: 'Listing Name', className: 'w-200' },
  { title: 'Date', className: 'w-200' },
  { title: 'Approval For', className: 'w-200' },
  { title: 'New Changes', className: 'w-200' },
  { title: 'Action', className: 'w-200' },
]

export const VideoTable = ({
  videos,
  isLoading,
  setLoading,
  fetchVideoApprovals
}) => {
  const [selectedItem, setSelectedItem] = useState(null)
  const [openApprovalModal, setOpenApprovalModal] = useState(false)

const fieldType = (id) => {
  switch (id) {
    case 1:
      return "Name"
    case 2:
      return "Description"
    case 5:
      return "Important Information"
    default:
      return "Video"
  }
}

const PendingApproval = (type, reason) => {
  setLoading(true);
  if (type) {
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}/listing/approval/${selectedItem.id}?listing_id=${selectedItem.listing_id}&is_approved=true`
      )
      .then((res) => {
        toast.success("Approval Accepted");
        fetchVideoApprovals();
        setSelectedItem(null)
        setLoading(false)
        setOpenApprovalModal(false)
      })
      .catch((err) => {
       if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message || "Error in Accepting Approval");
          setLoading(false)
        }
      });
  } else {
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}/listing/approval/${selectedItem.id}?listing_id=${selectedItem.listing_id}&is_approved=false&reason=${reason}`
      )
      .then((res) => {
        toast.success("Approval Rejected");
        fetchVideoApprovals();
        setSelectedItem(null)
        setLoading(false)
        setOpenApprovalModal(false)
      })
      .catch((err) => {
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message || "Error in Rejecting Approval");
          setLoading(false)
        }
      });
  }
};

  return (
    <KTCardBody className='py-4'>
      {/* <h6 style={{ color: '#7e8299', textAlign: 'right' }}>Total: {total}</h6> */}
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map(column => (
                <th
                  key={column.title}
                  className={column.className}
                  style={{textAlign: column.title === 'Action' ? 'center' : 'left'}}
                >
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold'>
            {videos.length > 0 && (
              videos.map((row) => (
                <tr key={row.id}>
                  <td className='w-200' style={{minWidth:'180px'}}><Link to={`/listings/${row.listing_id}`} style={{color:'inherit'}}>{row.listing_name || '-'}</Link></td>
                  <td className='w-200' style={{minWidth:'180px'}}>{dayjs(row.created_at).format('MMMM DD YYYY')}</td>
                  <td className='w-200' style={{minWidth:'180px'}}>{fieldType(row.field_id) || '-'}</td>
                  <td className='w-200' style={{minWidth:'180px', maxWidth:'250px'}}>
                    {row.field_id == 2 ? 
                    <p dangerouslySetInnerHTML={{__html: row.value}} />
                    : row.field_id == 24 ?
                    <a href={row.value} target="_blank"><span style={{padding:'10px', fontWeight: '700', background:'#ffa459', borderRadius: '12px', color:'#fff'}}>View Video</span></a>
                    : row.value
                    }
                  </td>
                  <td className='w-200' style={{textAlign: 'center', display:'flex', gap:'5px', justifyContent:'flex-end'}}
                  ><span style={{padding:'10px', fontWeight: '700', background:'#2ecc71', borderRadius: '12px', color:'#fff', cursor:'pointer'}}
                  onClick={() => {
                    setSelectedItem({
                      ...row,
                      type: 'accept'
                    })
                    setOpenApprovalModal(true)
                  }}
                  >Approve</span>
                  <span style={{padding:'10px', fontWeight: '700', background:'#ed2626', borderRadius: '12px', color:'#fff', cursor:'pointer'}}
                   onClick={() => {
                    setSelectedItem({
                      ...row,
                      type: 'reject'
                    })
                    setOpenApprovalModal(true)
                   }}
                  >Reject</span>
                  </td>           
                </tr>
              ))
            )}
          </tbody>
        </table>
        {videos && !videos.length > 0 && 
        <div className='d-flex text-center text-gray-600 fw-bolder fs-6 w-100 align-content-center justify-content-center mt-10'>
         No matching records found
        </div>
        }
      </div>
      {isLoading && <UsersListLoading />}
      {
        openApprovalModal &&
        <ApprovalModal
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          openApprovalModal={openApprovalModal}
          setOpenApprovalModal={setOpenApprovalModal}
          fieldType={fieldType}
          isLoading={isLoading}
          onUpdate={PendingApproval}
        />
      }
    </KTCardBody>
  );
};
